module.exports = __webpack_public_path__ + "img/arrow-right.958119b8.svg";